import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import LoaderScreen  from "../others/LoaderScreen"
import AdminMainDashboard from "../dashboard/AdminMainDashboard";
const ProtectedRoute = ({ children }) => {
  const { authChecked, isAuthenticated , user } = useAuth();

  if (!authChecked) {
    return  <LoaderScreen/>
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user) {
    return <div>Loading..</div>;
  } 


  switch (user.role) {
    case "admin":
      return <AdminMainDashboard />;

    default:
      return <p>Unauthorized</p>;
  }


  
  return children;


};

export default ProtectedRoute;